<!-- 特典を探す キーワード入力 -->
<template>
  <section class="crly-m-common-search-keyword-input-form">
    <crlyAtomsCommonSearchKeywordInput
      @focusoutKeyword="$listeners['focusoutKeyword']"
    />
    <crlyAtomsCommonSearchKeywordBtn @clickSearchBtn="clickSearchBtn" />
  </section>
</template>

<script>
import CrlyAtomsCommonSearchKeywordInput from "@crly/components/atoms/common/search/keyword/Input.vue";
import CrlyAtomsCommonSearchKeywordBtn from "@crly/components/atoms/common/search/keyword/Btn.vue";

export default {
  name: "crlyMoleculesCommonSearchInputForm",
  components: {
    CrlyAtomsCommonSearchKeywordInput,
    CrlyAtomsCommonSearchKeywordBtn
  },
  props: {},
  data() {
    return {};
  },
  methods: {
    clickSearchBtn() {
      this.$emit("clickSearchBtn");
    }
  }
};
</script>

<style lang="scss" scoped></style>
